import React from 'react';
import styles from './style.module.css';

export default class ErrorComponent extends React.Component {
    state = {
        hasError: false,
        message: '',
    }

    componentDidCatch(error) {
        this.setState({
            hasError: true,
            message: error.message,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.error}>
                    {this.state.message}
                </div>
            );
        }

        return this.props.children;
    }
}

export const withError = (Component) => {
    class ErrorBoundary extends React.Component { // Renombrado para evitar confusión
        state = {
            hasError: false,
            message: '',
        }

        componentDidCatch(error) {
            this.setState({
                hasError: true,
                message: error.message,
            });
        }

        retry = () => {
            this.setState({
                hasError: false,
                message: '',
            });
        }

        render() {
            const { forwardedRef, ...rest } = this.props;

            if (this.state.hasError) {
                console.error(this.state);
                return <div className={styles.error}>{this.state.message}</div>;
            }

            // Pasamos la ref capturada al componente original
            return <Component ref={forwardedRef} {...rest} />;
        }
    }

    // Usamos React.forwardRef para obtener la ref del consumidor
    const forwardRef = React.forwardRef((props, ref) => {
        return <ErrorBoundary {...props} forwardedRef={ref} />;
    });

    forwardRef.displayName = `withError(${Component.displayName || Component.name})`;

    return forwardRef;
};

